import type { PieceType } from './types';
import { PIECE_TYPES } from './pieces';

/** Deterministischer PRNG (mulberry32). Gleicher Seed → gleiche Folge. */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return function next(): number {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/**
 * 7-Bag-Randomizer: jede Sieben-Steine-Menge wird gemischt ausgegeben, bevor die
 * nächste beginnt. Deterministisch über den injizierten RNG.
 */
export class SevenBag {
  private queue: PieceType[] = [];

  constructor(private readonly rand: () => number) {}

  private refill(): void {
    const bag = [...PIECE_TYPES];
    // Fisher-Yates mit dem injizierten RNG.
    for (let i = bag.length - 1; i > 0; i--) {
      const j = Math.floor(this.rand() * (i + 1));
      const tmp = bag[i];
      bag[i] = bag[j];
      bag[j] = tmp;
    }
    this.queue.push(...bag);
  }

  /** Nächsten Stein entnehmen. */
  next(): PieceType {
    if (this.queue.length === 0) this.refill();
    return this.queue.shift()!;
  }

  /** Vorschau auf den nächsten Stein, ohne ihn zu entnehmen. */
  peek(): PieceType {
    if (this.queue.length === 0) this.refill();
    return this.queue[0];
  }
}
